import { render, staticRenderFns } from "./Reserves.vue?vue&type=template&id=761aa9ee&"
import script from "./Reserves.vue?vue&type=script&lang=js&"
export * from "./Reserves.vue?vue&type=script&lang=js&"
import style0 from "./Reserves.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports